import { config } from './lib/config'
// base directory of this module
config.appDir = __dirname + '/..'
export * from './lib/index'
export * from './lib/model'
export { initialOpts } from './lib/config'
